// SIDE DRAWER
export const SIDE_DRAWER_MAX_WIDTH = 400;
export const SIDE_DRAWER_Z_INDEX = 1401;
export const SIDE_CHILD_DRAWER_Z_INDEX = 1500;
export const SIDE_DRAWER_BACKDROP_Z_INDEX = 1400;

// HEADER
export const DRAWER_WIDTH: number = 360;
export const COLLAPSED_DRAWER_WIDTH: number = 57;
